// ── ISO-3166 alpha-3 → alpha-2 mapping (API returns alpha-3 like "USA", "NLD") ──
export const A3_TO_A2 = {
  USA: "US",
  CAN: "CA",
  MEX: "MX",
  BRA: "BR",
  ARG: "AR",
  CHL: "CL",
  COL: "CO",
  PER: "PE",
  GBR: "GB",
  FRA: "FR",
  DEU: "DE",
  ESP: "ES",
  ITA: "IT",
  NLD: "NL",
  BEL: "BE",
  CHE: "CH",
  AUT: "AT",
  SWE: "SE",
  NOR: "NO",
  DNK: "DK",
  FIN: "FI",
  POL: "PL",
  PRT: "PT",
  IRL: "IE",
  CZE: "CZ",
  ROU: "RO",
  GRC: "GR",
  TUR: "TR",
  RUS: "RU",
  UKR: "UA",
  HUN: "HU",
  HRV: "HR",
  BGR: "BG",
  SVK: "SK",
  SVN: "SI",
  LTU: "LT",
  LVA: "LV",
  EST: "EE",
  SRB: "RS",
  IND: "IN",
  CHN: "CN",
  JPN: "JP",
  KOR: "KR",
  SGP: "SG",
  THA: "TH",
  MYS: "MY",
  IDN: "ID",
  PHL: "PH",
  VNM: "VN",
  TWN: "TW",
  HKG: "HK",
  BGD: "BD",
  PAK: "PK",
  LKA: "LK",
  ARE: "AE",
  SAU: "SA",
  ISR: "IL",
  QAT: "QA",
  KWT: "KW",
  BHR: "BH",
  OMN: "OM",
  JOR: "JO",
  AUS: "AU",
  NZL: "NZ",
  ZAF: "ZA",
  EGY: "EG",
  NGA: "NG",
  KEN: "KE",
  MAR: "MA",
  GHA: "GH",
  ETH: "ET",
  TZA: "TZ",
};

// ── Country → approximate lat/lng (capital cities) for GeoMap markers ──
export const COUNTRY_COORDS = {
  US: { lat: 39.8283, lng: -98.5795, name: "United States" },
  CA: { lat: 56.1304, lng: -106.3468, name: "Canada" },
  MX: { lat: 23.6345, lng: -102.5528, name: "Mexico" },
  BR: { lat: -14.235, lng: -51.9253, name: "Brazil" },
  AR: { lat: -38.4161, lng: -63.6167, name: "Argentina" },
  GB: { lat: 55.3781, lng: -3.436, name: "United Kingdom" },
  FR: { lat: 46.2276, lng: 2.2137, name: "France" },
  DE: { lat: 51.1657, lng: 10.4515, name: "Germany" },
  ES: { lat: 40.4637, lng: -3.7492, name: "Spain" },
  IT: { lat: 41.8719, lng: 12.5674, name: "Italy" },
  NL: { lat: 52.1326, lng: 5.2913, name: "Netherlands" },
  BE: { lat: 50.5039, lng: 4.4699, name: "Belgium" },
  CH: { lat: 46.8182, lng: 8.2275, name: "Switzerland" },
  AT: { lat: 47.5162, lng: 14.5501, name: "Austria" },
  SE: { lat: 60.1282, lng: 18.6435, name: "Sweden" },
  NO: { lat: 60.472, lng: 8.4689, name: "Norway" },
  DK: { lat: 56.2639, lng: 9.5018, name: "Denmark" },
  FI: { lat: 61.9241, lng: 25.7482, name: "Finland" },
  PL: { lat: 51.9194, lng: 19.1451, name: "Poland" },
  PT: { lat: 39.3999, lng: -8.2245, name: "Portugal" },
  IE: { lat: 53.1424, lng: -7.6921, name: "Ireland" },
  CZ: { lat: 49.8175, lng: 15.473, name: "Czech Republic" },
  RO: { lat: 45.9432, lng: 24.9668, name: "Romania" },
  GR: { lat: 39.0742, lng: 21.8243, name: "Greece" },
  TR: { lat: 38.9637, lng: 35.2433, name: "Turkey" },
  RU: { lat: 61.524, lng: 105.3188, name: "Russia" },
  IN: { lat: 20.5937, lng: 78.9629, name: "India" },
  CN: { lat: 35.8617, lng: 104.1954, name: "China" },
  JP: { lat: 36.2048, lng: 138.2529, name: "Japan" },
  KR: { lat: 35.9078, lng: 127.7669, name: "South Korea" },
  SG: { lat: 1.3521, lng: 103.8198, name: "Singapore" },
  TH: { lat: 15.87, lng: 100.9925, name: "Thailand" },
  MY: { lat: 4.2105, lng: 101.9758, name: "Malaysia" },
  ID: { lat: -0.7893, lng: 113.9213, name: "Indonesia" },
  PH: { lat: 12.8797, lng: 121.774, name: "Philippines" },
  VN: { lat: 14.0583, lng: 108.2772, name: "Vietnam" },
  TW: { lat: 23.6978, lng: 120.9605, name: "Taiwan" },
  HK: { lat: 22.3193, lng: 114.1694, name: "Hong Kong" },
  AE: { lat: 23.4241, lng: 53.8478, name: "UAE" },
  SA: { lat: 23.8859, lng: 45.0792, name: "Saudi Arabia" },
  IL: { lat: 31.0461, lng: 34.8516, name: "Israel" },
  QA: { lat: 25.3548, lng: 51.1839, name: "Qatar" },
  AU: { lat: -25.2744, lng: 133.7751, name: "Australia" },
  NZ: { lat: -40.9006, lng: 174.886, name: "New Zealand" },
  ZA: { lat: -30.5595, lng: 22.9375, name: "South Africa" },
  EG: { lat: 26.8206, lng: 30.8025, name: "Egypt" },
  NG: { lat: 9.082, lng: 8.6753, name: "Nigeria" },
  KE: { lat: -0.0236, lng: 37.9062, name: "Kenya" },
  CL: { lat: -35.6751, lng: -71.543, name: "Chile" },
  CO: { lat: 4.5709, lng: -74.2973, name: "Colombia" },
  PE: { lat: -9.19, lng: -75.0152, name: "Peru" },
};

// ── FW freshness bucket labels (API keys → display labels) ──
export const FW_BUCKET_LABELS = {
  lt_7d: "< 7 days",
  "7d_to_30d": "7–30 days",
  "30d_to_90d": "30–90 days",
  gt_90d: "> 90 days",
};

// ── OCPP connector status → StatusDonutChart bucket mapping ──
export const CONNECTOR_STATUS_MAP = {
  AVAILABLE: "online",
  CHARGING: "charging",
  FAULTED: "faulted",
  SUSPENDED_EVSE: "preparing",
  SUSPENDED_EV: "preparing",
  PREPARING: "preparing",
  FINISHING: "charging",
  UNAVAILABLE: "offline",
  OCCUPIED: "charging",
};

// ── Reverse lookup: country name (upper-cased) → alpha-2 code ──
const NAME_TO_A2 = {};
Object.entries(COUNTRY_COORDS).forEach(([a2, { name }]) => {
  NAME_TO_A2[name.toUpperCase()] = a2;
});

// ── Helpers ──
export function resolveCountryCode(raw) {
  const upper = raw.trim().toUpperCase();
  if (upper.length === 2) return upper;
  if (upper.length === 3 && A3_TO_A2[upper]) return A3_TO_A2[upper];
  return NAME_TO_A2[upper] || upper;
}

export function toTitleCase(str) {
  if (!str) return str;
  return str.toLowerCase().replace(/(?:^|\s|[-_])\S/g, match => match.toUpperCase());
}

export function mapToChartData(obj, labelFn) {
  if (!obj || typeof obj !== "object") return null;
  const entries = Object.entries(obj);
  if (entries.length === 0) return null;

  // Two-pass merge:
  // 1. Compute display name for each entry
  // 2. Merge entries with the same display name (case-insensitive)
  const merged = {};
  const rawKeys = {};
  entries.forEach(([key, val]) => {
    const displayName = labelFn ? labelFn(key) : toTitleCase(key);
    const mergeKey = displayName.toUpperCase();
    merged[mergeKey] = (merged[mergeKey] || 0) + (Number(val) || 0);
    // Keep the display name and raw key from the first occurrence
    if (!rawKeys[mergeKey]) rawKeys[mergeKey] = { displayName, rawKey: key };
  });

  const chartData = Object.entries(merged)
    .map(([mergeKey, value]) => ({
      name: rawKeys[mergeKey].displayName,
      value,
      rawKey: rawKeys[mergeKey].rawKey,
    }))
    .filter(d => d.value > 0)
    .sort((a, b) => b.value - a.value);

  if (chartData.length === 0) return null;
  const total = chartData.reduce((s, d) => s + d.value, 0);
  return { chartData, total };
}
